<script>

import {
  Signature,
  recoverPublicKey,
} from '@noble/secp256k1'

// import * as h from '@noble/hashes'
import { keccak_256 } from 'js-sha3'

const to_utf8 = text => new TextEncoder().encode(text)
const to_hex  = data => [].map.call(data, x => x.toString(16).padStart(2, '0')).join('')

const personal_prefix = to_utf8('\x19Ethereum Signed Message:\n')
const personal_encode = data => [
  personal_prefix,
  to_utf8(data.length + ''),
  data,
]

const keccak = data => {
  const hash = keccak_256.create()
  for (const x of data)
    hash.update(x)
    return new Uint8Array(hash.buffer())
}

const to_r = signature => BigInt  (       signature.slice( 0, 66))
const to_s = signature => BigInt  ('0x' + signature.slice(66, 66 + 64))
const to_v = signature => parseInt('0x' + signature.slice(-2), 16) - 27

const recover = (hash, r, s, v) => recoverPublicKey(
  hash,
  new Signature(r, s),
  v,
).subarray(1)

  export let address
  export let message
  export let signature

  const r = to_r(signature)
  const s = to_s(signature)
  const v = to_v(signature)

  const data          = to_utf8(message)
  const personal_data = personal_encode(data)
  const personal_hash = keccak(personal_data)

  const key  = recover(personal_hash, r, s, v)
  const hash = keccak([key])

  const verify = to_hex(hash.subarray(-20)) === address.slice(2)

  const color = {
    prefix  : 'aqua',
    length  : 'teal',
    content : 'blue',

    keyhash : 'maroon',
    address : 'red',
  }
</script>

<style>

  dl {
    font-family : monospace;
    font-size   : 120%;
  }
  dt {
    margin-top  : 1em;
  }

</style>

<h1> verify :
  <span style="color: {verify? 'green': 'red'}">
    { verify? 'success': 'failure' }
  </span>
</h1>

<dl>

  <dt>signature = personal_sign(text, address)</dt>
  <dd>{signature}</dd>

  <dt>r</dt>
  <dd>0x<span>{r.toString(16)}</span></dd>

  <dt>s</dt>
  <dd><span style="visibility: hidden"
               >{r.toString(16)}</span
       >0x<span>{s.toString(16)}</span></dd>

  <dt>v = 0x{signature.slice(-2)} - 27</dt>
  <dd>{v}</dd>

  <dt>text</dt>
  <dd>'{message}'</dd>

  <dt>data = to_utf8(text)</dt>
  <dd><span style="visibility: hidden"
           >{'0'.repeat(52)}</span
     ><span style="visibility: hidden"
           >{to_hex(personal_data[1])}</span
     ><span>0x</span
     ><span style="color: {color.content}"
           >{to_hex(data)}</span></dd>

  <dt>personal_data = '\x19Ethereum Signed Message:\n' + data.length + data</dt>
  <dd>0x<span style="color: {color.prefix}"
              title="'\x19Ethereum Signed Message:\n'"
             >{to_hex(personal_data[0])}</span
       ><span style="color: {color.length}"
              title="'{data.length}'"
             >{to_hex(personal_data[1])}</span
       ><span style="color: {color.content}"
              title="data"
             >{to_hex(personal_data[2])}</span></dd>

  <dt>personal_hash = keccak(personal_data)</dt>
  <dd>0x{to_hex(personal_hash)}</dd>

  <dt>key = recover(personal_hash, r, s, v)</dt>
  <dd>0x{to_hex(key)}</dd>

  <dt>hash = keccak(key)</dt>
  <dd>0x<span style="color: {color.keyhash}"
             >{to_hex(hash.subarray(0, -20))}</span
       ><span style="color: {color.address}"
             >{to_hex(hash.subarray(   -20))}</span></dd>

  <dt>address</dt>
  <dd><span style="visibility: hidden"
           >{'0'.repeat(24)}</span
     ><span style="color: {color.address}"
           >{address}</span></dd>

</dl>
